import { DashboardStore } from "src/app/dashboard/dashboard.store";
import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { ConversationsService } from "../conversations.service";
import { DashboardService } from "../../dashboard.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { HotToastService } from "@ngneat/hot-toast";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { FileUploadModalComponent } from "../../main/accountant/modals/file-upload-modal.component";
import { JobsService } from "../../main/accountant/jobs-and-tasks/jobs.service";
import { NewTrackedItemModalComponent } from "../modals/new-tracked-item-modal.component";
import { JobsStore } from "../../main/accountant/jobs-and-tasks/jobs.store";
import {
  PinnedItem,
  PinnedModels,
  PinnedModelsApps,
} from "../../main/accountant/pinned-panel/pinned-models";
import { PinnedService } from "../../main/accountant/pinned-panel/pinned.service";
import { NotesService } from "../../main/accountant/notes/notes.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { RealTimeService } from "../../main/common/notifications/real-time.service";
import { Channel } from "pusher-js";
import { EscapeHtmlPipe } from "../sanitizer.pipe";
import { MomentModule } from "ngx-moment";
import { UploadProgressBarComponent } from "../../../utils/upload-progress-bar/upload-progress-bar.component";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";

import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { FormsModule } from "@angular/forms";
import { FilePreviewDirective } from "../../main/common/file-preview.directive";

import { TooltipModule } from "ngx-bootstrap/tooltip";
import { TooltipModule as PrimeNGTooltipModule } from "primeng/tooltip";
import { NgClass, NgStyle, NgPlural, NgPluralCase } from "@angular/common";
import { EditorModule } from "primeng/editor";
import { SkeletonModule } from "primeng/skeleton";
import { IconCounterComponent } from "src/app/design-system/components/icon-counter/icon-counter.component";

import { PinComponent } from "src/app/design-system/components/pin/pin.component";
import { StatusBadgeComponent } from "src/app/design-system/components/status-badge/status-badge.component";
import { SharedDataService } from "../../shared-data.service";
import { ConfirmationModalComponent } from "../../main/accountant/modals/confirmation-modal.component";

@Component({
  selector: "tracked-item-bubble",
  templateUrl: "./tracked-item-bubble.component.html",
  styleUrls: ["./tracked-item-bubble.component.scss"],
  imports: [
    NgClass,
    TooltipModule,
    NgStyle,
    FilePreviewDirective,
    FormsModule,
    BsDropdownModule,
    NgPlural,
    NgPluralCase,
    TypeaheadModule,
    UploadProgressBarComponent,
    MomentModule,
    EscapeHtmlPipe,
    EditorModule,
    SkeletonModule,
    IconCounterComponent,
    PinComponent,
    StatusBadgeComponent,
    PrimeNGTooltipModule,
  ],
})
export class TrackedItemBubbleComponent implements OnInit, OnDestroy {
  autoRemind = false;
  autoRemindDays = "2";
  isOpen = false;
  isAccountant = false;
  isSendingComment = false;
  loading = false;

  showProgressBar: boolean = false;
  progressPercentage: number = 0;

  @Input() tracked_item: any;
  @Input() user: any;
  @Input() conversation: any;
  @Input() accounts: any = [];
  @Input() classes: any = { enabled: false, classes: [] };
  @Input() hasSelectableClass: any = false;
  @Input() canAnswer: boolean = true;
  @Input() company: any;
  @Input() isDrawer: any = false;
  @Input() workspaceCard: any = false;
  @Input() shouldOpenDrawer: any;
  @Input() isTemplateManager: boolean = false;
  @Input() isPreview = false;
  ext: any = null;
  data: any;

  hovering = false;
  pinStatus = ""; // "", "pinned", "done"
  pinnedItem: PinnedItem;
  pinModel = PinnedModels.TrackedItem;

  @ViewChild("inputTrackedItemMessage") inputTrackedItemMessage: ElementRef;

  canEditTrackedItemMessage = this.isTemplateManager ? true : false;

  moment_calendar_format = {
    sameDay: "[Today -] h:mm A",
    nextDay: "[Tomorrow]",
    nextWeek: "[Next] dddd",
    lastDay: "[Yesterday -] H:mm A",
    lastWeek: "MMM D - h:mm A",
    sameElse: "MMM D - h:mm A",
  };

  bsFileUploadModalRef: BsModalRef;

  pusherChannel: Channel;

  constructor(
    private localStorage: LocalStorageService,
    private conversationsService: ConversationsService,
    public dashboardService: DashboardService,
    public _sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    public dashboardStore: DashboardStore,
    private toastr: HotToastService,
    private modalService: BsModalService,
    public jobsService: JobsService,
    private jobsStore: JobsStore,
    private pinnedService: PinnedService,
    private notesService: NotesService,
    private realTimeService: RealTimeService,
    private sharedDataService: SharedDataService,
  ) {}

  ngOnInit(): void {
    this.data = this.sharedDataService.data;
    this.isAccountant = this.sharedDataService.data.user_type === 1;
    this.user = this.sharedDataService.user;

    if (
      this.tracked_item !== null &&
      this.tracked_item.answer_filename !== null
    ) {
      this.ext = this.getFileExt(this.tracked_item.answer_filename);
    }

    if (this.tracked_item != null) {
      this.checkAutoRemind();
    }

    this.dashboardStore._selectTrackedItem.subscribe((sub) => {
      this.checkAutoRemind();
    });

    this.conversationsService.updateTrackedItem$.subscribe((data) => {
      if (this.tracked_item.uuid === data.uuid) {
        this.tracked_item = {
          ...this.tracked_item,
          message: data.message,
          type: data.type,
          attachments: data.files,
          attachments_qty: data.files?.length,
          selected_folder_to_receive_files:
            data.selected_folder_to_receive_files,
        };
        this.cdr.detectChanges();
      }
    });

    this.pusherChannel = this.realTimeService.pusher.subscribe(
      `tracked-item.${this.tracked_item.uuid}`,
    );

    this.pusherChannel.bind("tracked-item-update", (msg: any) => {
      console.log("update");
      this.tracked_item = msg.tracked_item;

      if (msg.should_reload) {
        this.conversationsService
          .get_tracked_item(this.tracked_item.uuid)
          .then((res: any) => {
            this.tracked_item = res.tracked_item;
          });
      }
    });
  }

  ngOnDestroy(): void {
    this.pusherChannel.unbind("tracked-item-update");
    this.pusherChannel.unsubscribe();
  }

  canAutopilot(): boolean {
    if (this.tracked_item != null) {
      return ["draft", "open"].includes(this.tracked_item.answer_status);
    }
    return false;
  }

  checkAutoRemind() {
    this.autoRemind = this.tracked_item.initial_reminder_date ? true : false;

    const reminderDate = new Date(this.tracked_item.initial_reminder_date);
    const calculatedDays = Math.round(
      Math.floor(
        reminderDate.getTime() - new Date(this.tracked_item.date).getTime(),
      ) /
        (1000 * 60 * 60 * 24),
    );
    this.autoRemindDays = calculatedDays < 0 ? "0" : calculatedDays.toString();
    // console.log("calculated", calculatedDays, this.autoRemindDays);
  }

  saveAutoRemindSettings() {
    const initialRemindDate = new Date();
    this.tracked_item.initial_reminder_date = this.autoRemind
      ? initialRemindDate.setDate(
          initialRemindDate.getDate() + parseInt(this.autoRemindDays),
        )
      : null;
    this.conversationsService
      .setAutoRemind(
        this.tracked_item.uuid,
        this.autoRemind ? this.autoRemindDays : null,
      )
      .subscribe(
        (res) => this.handleSuccessSetAutoRemind(res),
        (err) => this.handleError(err),
      );
  }

  handleSuccessSetAutoRemind(res: any) {
    console.log(res.message);
  }

  sanitize(image) {
    return this._sanitizer.bypassSecurityTrustUrl(`${image}`);
  }

  hasComments(numComments: number) {
    if (numComments > 0) {
      return true;
    } else {
      return false;
    }
  }

  goToTrackedItem(message): void {
    console.log(message);
    this.conversationsService.showTrackedItems.next({
      state: true,
      message: message,
    });
  }

  private hasParentWithAttribute(
    element: HTMLElement,
    attributeName: string,
  ): boolean {
    // Traverse up the DOM tree to check each parent element
    while (element) {
      if (element.hasAttribute(attributeName)) {
        return true;
      }
      element = element.parentElement as HTMLElement;
    }
    return false;
  }

  openDrawer(event: MouseEvent, tracked_item, company): void {
    console.log("Opening Drawer", tracked_item);

    const targetElement = event.target as HTMLElement;
    event.stopPropagation();

    if (
      this.shouldOpenDrawer &&
      !targetElement.hasAttribute("skip-drawer") &&
      !this.hasParentWithAttribute(targetElement, "skip-drawer")
    ) {
      this.dashboardStore.selectTrackedItem(tracked_item, company);
    }
  }

  goToOpenTrackedItems(): void {
    this.conversationsService.showOpenTrackedItems.next({});
  }

  getFileExt(filename) {
    if (filename != null) {
      return filename.split(".")[1];
    } else {
      return null;
    }
  }

  answerTrackedItem(tracked_item, satisfied): void {
    this.dashboardService.show_loading.next(true);
    this.conversationsService
      .answer_tracked_item(tracked_item.id, satisfied)
      .then(
        (res: any) => {
          const response = res;
          tracked_item = response.tracked_item;
          // this.toastr.success(res.message);
          this.loading = false;
          this.dashboardService.show_loading.next(false);

          if (satisfied && res.is_last_task) {
            this.jobsService.jobCompletedConfirmation(
              res.job_uuid,
              this.modalService,
              ConfirmationModalComponent,
              this.toastr,
            );
          }
        },
        (err) => {
          // this.toastr.error(err.error.message);
          this.loading = false;
          this.dashboardService.show_loading.next(false);
        },
      );
  }

  submitAnswer(tracked_item): void {
    this.loading = true;
    let fileForm = new FormData();
    for (let y = 0; y < tracked_item.files.length; y++) {
      if (tracked_item.files[y]["id"] == null) {
        fileForm.append(
          "files",
          tracked_item.files[y],
          tracked_item.files[y].name,
        );
      }
    }

    fileForm.append(
      "qbo_account",
      JSON.stringify(tracked_item.selectedAccount),
    );
    if (tracked_item.selectedClassId != null) {
      fileForm.append(
        "qbo_class",
        JSON.stringify(tracked_item.selectedClassId),
      );
    }
    fileForm.append("tracked_item_id", tracked_item.id);
    fileForm.append("answer", tracked_item.answer);
    fileForm.append("answer_text", tracked_item.answer_text);
    fileForm.append("answer_done", tracked_item.answer_done);

    // this.dashboardService.show_loading.next(true);
    this.conversationsService
      .submit_answer_v2(this.conversation.id, fileForm)
      .subscribe(
        (res: any) => {
          if (tracked_item.files.length > 0) {
            this.loading = false;
            this.showProgressBar = true;
            if (res?.status === "progress") {
              let serverPercentage = res?.message;
              this.progressPercentage = serverPercentage;
              this.cdr.detectChanges();
              console.log("PROGRESS: ", this.progressPercentage);
              if (this.progressPercentage === 100) {
                this.showProgressBar = false;
                this.loading = true;
                this.cdr.detectChanges();
              }
            } else if (res?.status === "completed") {
              this.cdr.detectChanges();
              this.showProgressBar = false;
              this.progressPercentage = 0;
            }
          }
        },
        (error: any) => {
          this.loading = false;
          this.progressPercentage = 0;
          this.showProgressBar = false;
          console.log(error);
        },
        () => {
          this.showProgressBar = false;
          this.loading = false;
        },
      );
    // .then(
    //   (res: any) => {
    //     this.tracked_item["pendingUpload"] = true;
    //     this.loading = false;
    //   },
    //   (err) => {
    //     console.log(err);
    //     this.loading = false;
    //   }
    // );
  }

  selectClass(event: any, tracked_item: any) {
    console.log(event);
    tracked_item.selectedClass = event.item.name;
    tracked_item.selectedClassId = event.item;
  }

  selectAccount(event: any, tracked_item: any) {
    tracked_item.selectedAccount = event.item;
    tracked_item.selectedAcc = event.item.name;
  }

  send_comment(message, tracked_item_id, input): void {
    this.conversationsService
      .comment_tracked_item(tracked_item_id, message)
      .then((res: any) => {
        input.value = "";
        input.focus();
      });
  }

  trackById(index, tracked_item) {
    return tracked_item.id;
  }

  showFilename(event, tracked_item) {
    event.target.innerHTML = `<i class="feather download"></i> ${tracked_item.answer_filename}`;
  }

  showDefaultFilename(event) {
    event.target.innerHTML = `<i class="feather download"></i> Download file`;
  }

  shouldDisable(tracked_item) {
    if (!this.canAnswer) return true;

    if (this.tracked_item.is_draft) return true;

    if (tracked_item.type == 6) {
      return (
        tracked_item.selectedAcc == null ||
        tracked_item.selectedAcc == undefined
      );
    }

    if (tracked_item.type == 2) {
      if (tracked_item.files == null || tracked_item.files.length == 0) {
        return true;
      }

      if (tracked_item.files.length == tracked_item.files_qty) {
        return true;
      }
    }

    return (
      ((tracked_item.type == 1 || tracked_item.type == 4) &&
        (tracked_item.answer == null || tracked_item.answer == undefined)) ||
      (tracked_item.type == 3 &&
        (tracked_item.answer_text == null ||
          tracked_item.answer_text == undefined ||
          tracked_item.answer_text == "")) ||
      (tracked_item.type == 5 &&
        (tracked_item.answer_done == null ||
          tracked_item.answer_done == undefined ||
          tracked_item.answer_done == false))
    );
  }

  closeTrackedItem(tracked_item): void {
    this.dashboardService.show_loading.next(true);
    this.conversationsService.close_tracked_item(tracked_item.id).subscribe(
      (res: any) => {
        this.dashboardService.show_loading.next(false);
        console.log("trackedItem before close", tracked_item);
        this.tracked_item = res.tracked_item;
        console.log("trackedItem after close", tracked_item);
        this.dashboardStore.updateTrackedItem(
          tracked_item.conversation,
          this.tracked_item,
        );
        this.cdr.detectChanges();
      },
      (err) => {
        // this.toastr.error(err.error.message);
        this.dashboardService.show_loading.next(false);
      },
    );
  }

  deleteTrackedItem(tracked_item): void {
    this.dashboardService.show_loading.next(true);
    this.conversationsService.close_tracked_item(tracked_item.id).subscribe(
      (res: any) => {
        this.dashboardService.show_loading.next(false);
        console.log("trackedItem before close", tracked_item);
        this.tracked_item = res.tracked_item;
        console.log("trackedItem after close", tracked_item);
        this.dashboardStore.updateTrackedItem(
          tracked_item.conversation,
          this.tracked_item,
        );
        this.cdr.detectChanges();
      },
      (err) => {
        // this.toastr.error(err.error.message);
        this.dashboardService.show_loading.next(false);
      },
    );
  }

  editTrackedItemMessage(elem: any) {
    if (this.data.user_type !== 1) {
      return;
    }
    this.canEditTrackedItemMessage = !this.canEditTrackedItemMessage;
  }

  updateTrackedItemMessage(updatedElem: any) {
    this.conversationsService
      .updateTrackedItemMessage(
        this.conversation.id,
        this.tracked_item.uuid,
        updatedElem.innerHTML,
      )
      .subscribe(
        (res: any) => {
          this.tracked_item = res.tracked_item;
          this.dashboardStore.updateTrackedItem(
            this.conversation.id,
            this.tracked_item,
          );
          this.canEditTrackedItemMessage = false;
          this.toastr.success(res.message);
        },
        (err) => this.handleError(err),
      );
  }

  handleError(err: any) {
    this.toastr.error(err.message);
  }

  public openModalFileUpload() {
    this.bsFileUploadModalRef = this.modalService.show(
      FileUploadModalComponent,
      {
        initialState: {
          currentConversationID: this.conversation.id,
          formdataOnly: true,
        },
      },
    );

    this.bsFileUploadModalRef.content.onUpload.subscribe((files) => {
      console.log(files);
      if (this.tracked_item.files == null) {
        this.tracked_item.files = [];
      }

      this.tracked_item.files = this.tracked_item.files.concat(files);

      this.tracked_item.files.forEach((file) => {
        if (file["id"] == null) {
          let url = URL.createObjectURL(file);
          file["filename"] = file.name;
          file["url"] = url;
          file["ext"] = this.getFileExt(file.name);
          file["tracked_item"] = this.tracked_item.uuid;
        }
      });

      this.tracked_item["pendingUploadQty"] = this.tracked_item.files.filter(
        (f) => f["id"] == null,
      ).length;

      this.cdr.detectChanges();

      console.log(this.tracked_item.files);
    });
  }

  //open deleteTrackedItem modal
  public openDeleteTrackedItemModal() {
    this.dashboardService.openDeleteTrackedItemModal.next(this.tracked_item);
  }

  launchAdvancedEdit() {
    const trackedItemCopy = { ...this.tracked_item };
    console.log("THE TRACKED ITEM COPY", trackedItemCopy);
    trackedItemCopy.files = trackedItemCopy.attachments;
    let bsModalRef = this.modalService.show(NewTrackedItemModalComponent, {
      class: "modal-lg",
      ignoreBackdropClick: true,
      initialState: {
        editMode: true,
        tracked_items: [trackedItemCopy],
      },
    });

    bsModalRef.content.messageEvent.subscribe((data) => {
      console.log("DATA (TRACKED-ITEM)", data);
      this.tracked_item.message = data.message;
      this.tracked_item.type = data.type;
      this.tracked_item.attachments = data.files;
      this.tracked_item.attachments_qty = data.files?.length;
      this.tracked_item.clients_to_notify = data.clients_to_notify;
      this.cdr.detectChanges();
      console.log("TRACKED ITEM EDITED", this.tracked_item);
    });
  }

  async openRelatedJobPanel(jobUuid: string, event: any) {
    console.log("THE EVENT", event);
    event.stopPropagation();
    const job = await this.jobsService.getJob(jobUuid);
    this.jobsStore.changeSelectedJob.next(job);
  }

  async pinTrackedItem() {
    const { uuid: companyUuid } = await this.notesService.getCompanyUuid(
      this.tracked_item.company,
    );
    const data = {
      model_name: PinnedModels.TrackedItem,
      model_app_name: PinnedModelsApps.TrackedItem,
      object_pk: this.tracked_item["id"],
    };

    const { pinned_item, message } = await this.pinnedService.pinItem(
      data,
      companyUuid,
    );

    this.cdr.detectChanges();

    this.toastr.success(message);
  }

  goToQuickBooks(tracked_item): void {
    const id =
      tracked_item?.integration_data?.purchase_id != null
        ? tracked_item?.integration_data?.purchase_id
        : tracked_item?.integration_data?.deposit_id;

    window.open(
      `https://app.qbo.intuit.com/app/expense?txnId=${id}
    `,
      "_blank",
    );
  }

  getCommentCount() {
    return this.tracked_item.comments?.filter((c) => c.is_deleted !== true)
      .length;
  }
}
